import React, { Dispatch, SetStateAction } from 'react'
import SendGTAGEvent from '../../utils/sendGTAGEvent';

import FilterButton from '../FilterButton'
import FilterCategoryModal from '../FilterCategoryModal';

import { Container } from './styles'

interface IFilterState {
    search: string;
    category: string;
    brands: string;
}

interface IFilterProps {
    filterConfigsCategory: {
        shouldHide: boolean;
        filterName: string;
        filterTitle: string;
        filterType: 'radio' | any;
        filterItems?: {
            filterItemName: string;
            filterItemValue: string | number[];
        }[];
        isOpen: boolean;
    }[]
    onClearPage: () => void;
    onChangeFilterStatesHandler: (filterKey: string) => void;
    onClick: () => void;
    onCloseModal: () => void;
    isOpen: boolean;
    setFilter: Dispatch<SetStateAction<IFilterState>>;
    onClearFilter: () => void;
    activeCategoryCount?: number;
    className: string;
    shouldUseArrow?: boolean;
}

const FilterCategory: React.FC<IFilterProps> = ({
    className,
    filterConfigsCategory,
    onClearPage,
    onChangeFilterStatesHandler,
    isOpen,
    onCloseModal,
    onClick,
    setFilter,
    onClearFilter,
    activeCategoryCount,
    shouldUseArrow,
    children
}) => (
    <Container className={className}>
        <FilterButton
            onClick={() => {
                onClick()
                SendGTAGEvent(
                    'botao_categoria',
                    'Categoria',
                    'Clicou em botão "Categorias"')
            }
            }
            counter={activeCategoryCount}
            shouldUseArrow={shouldUseArrow}
            isOpen={isOpen}>
            {children}
        </FilterButton>

        <FilterCategoryModal
            isOpen={isOpen}
            onClose={onCloseModal}
            filterConfigs={filterConfigsCategory}
            className={className}
            setFilter={setFilter}
            onClearPage={onClearPage}
            onClearFilter={onClearFilter}
            onChangeFilterStatesHandler={onChangeFilterStatesHandler}
        >
            {children}
        </FilterCategoryModal>
    </Container>
)

export default FilterCategory